import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center bg-warm-brown overflow-hidden" data-id="element-198">
      {/* Cinematic Background Video */}
      <div className="absolute inset-0" data-id="element-199">
        <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-200">
          <source src="https://cdn.magicpatterns.com/uploads/2oWbBX7v5ujB7kHyJsgstD/AZ0GsRgcSOpweeM6Lr-C5w-AZ0GsRgcpQCLL6PTUAgGZA.mp4" type="video/mp4" data-id="element-201" />
        </video>
      </div>

      {/* Subtle gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-warm-brown/40 via-warm-brown/20 to-near-black/80" data-id="element-202"></div>

      {/* Grain texture overlay */}
      <div className="absolute inset-0 grain-overlay opacity-30" data-id="element-203"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-20" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-205">
          <h1 className="font-display italic text-4xl sm:text-5xl md:text-7xl lg:text-8xl text-cream leading-[1.1] mb-4 md:mb-6 drop-shadow-lg" data-id="element-206">
            Every crown <br data-id="element-207" /> deserves care.
          </h1>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 0.8
        }} className="text-sm sm:text-base md:text-xl text-cream/90 font-body uppercase tracking-[0.15em] md:tracking-[0.2em] mb-8 md:mb-12 drop-shadow-md" data-id="element-208">
            African braiding salon • Lanham, MD
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8,
          duration: 0.8
        }} className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6" data-id="element-209">
            <a href="tel:2409217857" className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-brand-gold text-cream font-bold uppercase tracking-widest text-xs sm:text-sm rounded-full hover:bg-near-black transition-colors shadow-lg hover:shadow-xl animate-gold-pulse" data-id="element-210">
              Call to Book
            </a>
            <Link to="/gallery" className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-brand-gold text-cream font-bold uppercase tracking-widest text-xs sm:text-sm rounded-full hover:bg-near-black transition-colors shadow-lg hover:shadow-xl" data-id="element-211">
              View Styles
            </Link>
          </motion.div>

          {/* Trust Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1,
          duration: 0.8
        }} className="mt-8 md:mt-16 flex flex-col sm:flex-row flex-wrap justify-center gap-3 md:gap-6 text-cream" data-id="element-212">
            <div className="flex items-center justify-center gap-2 bg-near-black/50 backdrop-blur-sm px-4 sm:px-6 py-2.5 sm:py-3 rounded-full border border-brand-gold/30 shadow-lg" data-id="element-213">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-brand-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-214">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-215"></path>
              </svg>
              <span className="text-xs sm:text-sm md:text-base font-body uppercase tracking-widest font-bold" data-id="element-216">
                5-Star Rated
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-near-black/50 backdrop-blur-sm px-4 sm:px-6 py-2.5 sm:py-3 rounded-full border border-brand-gold/30 shadow-lg" data-id="element-217">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-brand-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-218">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-219"></path>
              </svg>
              <span className="text-xs sm:text-sm md:text-base font-body uppercase tracking-widest font-bold" data-id="element-220">
                Expert Stylists
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-near-black/50 backdrop-blur-sm px-4 sm:px-6 py-2.5 sm:py-3 rounded-full border border-brand-gold/30 shadow-lg" data-id="element-221">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-brand-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-222">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-223"></path>
              </svg>
              <span className="text-xs sm:text-sm md:text-base font-body uppercase tracking-widest font-bold" data-id="element-224">
                Hair Care First
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}